import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Configurator from '../components/Configurator/Configurator';
import * as configuratorActionCreators from '../actions/actionCreators/configurator';
import { resetTextEditor, setTextColor } from '../actions/actionCreators/textEditor';
import { toggleVisibility as toggleIntroductionLayer } from '../actions/actionCreators/introductionLayer';
import {
    setCheckoutBehaviour,
    setStep as setCheckoutStep,
} from '../actions/actionCreators/checkout';
import * as transformAreaActionCreators from '../actions/actionCreators/transformArea';
import {
    showIntroductionLayerOnFirstVisit,
    initScene,
    fetchPenData,
    onImageUpload,
    minimumOrderMiddleware,
    areaSelectMiddleware,
} from '../actions/middleware/configurator';

function mapStateToProps(state) {
    let activeTemplate = null;
    if (state.configurator.activeTemplate) {
        activeTemplate = state.configurator.activeTemplate;
    } else if (state.configurator.hasOwnProperty('config')) {
        activeTemplate = state.configurator.config.template;
    }

    return {
        ...state.configurator,
        locale: state.app.locale,
        appIsLoading: state.app.isLoading,
        activeTemplate,
        customText: { ...state.textEditor },
        customColor: state.colorPicker.color,
        isTransformAreaOpen: state.transformArea.isOpen,
        isNotificationVisible: state.configurator.isNotificationVisible,
        disabledAreas: state.configurator.disabledAreas,
        texts: {
            'popup.reset.copy': state.app.texts['popup.reset.copy'],
            'configurator.head.help.icon.title':
                state.app.texts['configurator.head.help.icon.title'],
            'configurator.head.toggle.cap.icon.title':
                state.app.texts['configurator.head.toggle.cap.icon.title'],
            'configurator.head.reset.icon.title':
                state.app.texts['configurator.head.reset.icon.title'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    dispatch(showIntroductionLayerOnFirstVisit());
    return {
        // configurator
        ...bindActionCreators(configuratorActionCreators, dispatch),

        // transformArea
        ...bindActionCreators(transformAreaActionCreators, dispatch),

        // textEditor
        resetTextEditor: () => dispatch(resetTextEditor()),
        setTextColor: color => dispatch(setTextColor(color)),

        // introlayer & sidemenu
        toggleIntroductionLayer: () => dispatch(toggleIntroductionLayer()),

        // checkout
        ...bindActionCreators({ setCheckoutBehaviour, setCheckoutStep }, dispatch),

        // middleware
        fetchPenData: (slug, locale) => dispatch(fetchPenData(slug, locale)),
        initScene: slug => dispatch(initScene(slug)),
        onImageUpload: event => dispatch(onImageUpload(event)),
        minimumOrderMiddleware: (slug, config) => dispatch(minimumOrderMiddleware(slug, config)),
        areaSelectMiddleware: (slug, areaName) => dispatch(areaSelectMiddleware(slug, areaName)),
    };
}

const ConfiguratorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Configurator);

export default ConfiguratorContainer;
